export const SIZES = {
  medium: 'medium',
  large: 'large',
  stretch: 'stretch',
};
